module.exports = __webpack_public_path__ + "static/media/feedback.e4e648c2.PNG";